'use strict';
import axios from 'axios';
var ArctickClient = require('../../../../sdk/apiClient');
var util = require('util');

function Banners() {
    ArctickClient.apply(this, arguments);
}

const pluginId = process.env.BANNERS;
const tableName ='bp_manage_banners';

util.inherits(Banners, ArctickClient);

    /* *** Request GET: Get all Custom Table contents *** */
Banners.prototype.getBanners = function () {
        
        var deferred = $.Deferred();
            $.ajax({
            "method": "GET",
            "url": process.env.PROTOCOL + "://" + process.env.BASE_URL + '/api/v2/plugins/' + pluginId + '/custom-tables/' + tableName,
            "headers": {
                "Content-Type": "application/json",
                'Access-Control-Allow-Origin': '*',
            },
            success: function (response) {
                deferred.resolve(response.Records);
              },
            fail: function (data, status) {
                deferred.reject(data);
            },
            error: function (data, status) {
                deferred.reject(data);
            }
        });
        return deferred.promise();
}

module.exports = Banners;
